import PropTypes from 'prop-types';
import CategoryItem from './CategoryItem';
import GoFetch from '~/js/modules/fetchling';
import WeddingCircle from '../WeddingCircle';
import Modal from '~/js/components/global/Modal';
import ItemPanel from '../item-details/ItemPanel';
import LoginPanel from '../dashboard/LoginPanel';
import ReactLoader from '~/js/components/global/ReactLoader';

const fetch = new GoFetch();

export default class WishlistCatalogPanel extends React.Component {
  static propTypes = {
    events: PropTypes.array,
    ddlData: PropTypes.array,
    catalogData: PropTypes.array,
    countries: PropTypes.array
  };
  static defaultProps = {
    events: [],
    ddlData: [],
    catalogData: [],
    countries: []
  };
  constructor(props) {
    super(props);

    this.state = {
      isCeremony: true,
      activeCategory: null,
      activeSearchedCategory: null,
      items: null,
      itemDetails: {},
      isSuccessAdded: false,
      wishListModified: '',
      accountInfo: {},
      searchInputValue: '',
      isSearchedItem: false,
      notFound: false,
      isSignUp: true,
      isSearchActive: false,
    };
  }
  componentWillMount() {
    if (window.location.search.length) {
      const urlParams = this._retrieveURLParameters();

      if (urlParams.isCeremony && urlParams.category) {
        const isCeremony = (urlParams.isCeremony === 'true') ? true : false;
        const activeCategory = parseInt(urlParams.category, 10);

        this.setState({ isCeremony, activeCategory });
      }
    }
  }
  componentDidMount() {
    const ceremonyFilter = $('select[name="ceremony-filter"]');
    const categoryFilter = $('select[name="category-filter"]');

    $('.loader').hide();

    if (window.location.search.length) {
      const event = (this.state.isCeremony) ? 31 : 32;

      ceremonyFilter.on('change', () => {
        categoryFilter.val(this.state.activeCategory).trigger('change');
      });

      ceremonyFilter.val(event);
      categoryFilter.val(this.state.activeCategory).trigger('change');


      const onChangeEvent = document.createEvent('HTMLEvents');

      onChangeEvent.initEvent('change', true, true);

      const target = categoryFilter[0];

      target.dispatchEvent(onChangeEvent);
    } else {
      categoryFilter.val('default');
      $('.catalog-loader').hide();
    }
    this._fetchAllItems();
  }
  componentDidUpdate(prevState, nextState) {
    const ceremonyFilter = $('select[name="ceremony-filter"]');
    const event = (this.state.isCeremony) ? 31 : 32;

    if (prevState.isCeremony !== nextState.isCeremony) {
      ceremonyFilter.val(event).trigger('change');
    }
  }
  _eventDdlHandler = (e) => {
    const isCeremony = (e.target.value === '31') ? true : false;
    const categoryFilter = $('select[name="category-filter"]');

    categoryFilter.val('default');

    this.setState({isCeremony, activeCategory: null});
  };
  _categoryDdlHandler = (e) => {
    this.setState({ activeCategory: parseInt(e.target.value, 10) }, this._fetchSubCategoryItems);
  };
  _retrieveURLParameters = () => {
    const paramSplitter = (acc, currentEl) => {
      const splittedParams = currentEl.split('=');
      const key = splittedParams[0];
      const value = splittedParams[1];

      acc[key] = decodeURIComponent(value);

      return acc;
    };
    const urlParameters = window.location.search.slice(1).split('&').reduce(paramSplitter, {});

    return urlParameters;
  };
  _fetchSubCategoryItems = () => {
    const eventId = (this.state.isCeremony) ? 31 : 32;
    const subCategoryId = this.state.activeCategory;
    const requestBody = { eventId, subCategoryId };

    $('.catalog-loader').show();
    $('.category-container').hide();
    fetch.post('/weddings/subcategories/catalog/', null,  requestBody)
      .then((resp) => { // eslint-disable-line
        if(resp.status === 'fail') {
          console.warn('subCategoryId or event does not exist');
          $('select[name="category-filter"]').val('Select');
        } else {
          const catalogItems = [...resp.data.catalogItems].map((el) => {
            el.categoryName = el.subCategoryName;
            el.priceRange = `$${el.price}`;

            return el;
          });

          return catalogItems;
        }
      })
      .then((items) => {
        this.setState({ items, isSearchedItem: false, notFound: false });
        $('#searchCode').val('');
        $('.category-container').show();
        $('.catalog-loader').hide();
      });
  };
  _handleInputSearch = (e) => this.setState({searchInputValue: e.target.value});

  _searchItemByCode = () => {
    const inputValue = $('#searchCode').val();
    const itemFound = this.state.allItems.filter((el) => el.wishListSearchCode === inputValue);
    const hasItem = itemFound.length;

    $('.catalog-loader').show();
    $('.category-container').hide();

    hasItem > 0
      ? this.setState({items: itemFound, notFound: false, isSearchedItem: true, activeCategory: itemFound[0].subCategoryName, activeSearchedCategory: itemFound[0].subCategoryName})
      : this.setState({notFound: true});

    $('.catalog-loader').hide();
    $('.category-container').show();
  };
  _fetchAllItems = () => {
    const eventId = null;
    const subCategoryId = 0;
    const requestBody = { eventId, subCategoryId };

    fetch.post('/weddings/subcategories/catalog/', null,  requestBody)
      .then((resp) => this.setState({ allItems: resp.data.catalogItems }))
      .catch((err) => console.warn(err));
  };

  _getcategoryOptions = (ddlData, activeEvent) => ddlData.filter((obj) => obj.event === activeEvent);

  _getActiveCategoryIndex = (ddlData, activeEvent) => ddlData.findIndex((el) => el.event === activeEvent && el.value === this.state.activeCategory);

  _getActiveCategoryName = (ddlData, activeCategoryIndex) => (this.state.activeCategory && activeCategoryIndex !== -1) ? ddlData[activeCategoryIndex].realName : '';

  _renderCategoryOptions = (options) => options.map(opt => <option key={opt.value} value={opt.value}>{opt.name}</option>);

  _renderEventOptions = (events) => events.map(event => <option key={event.value} value={event.value}>{event.name}</option>);

  _updateItemDetail = (itemDetails) => {
    this.setState({ itemDetails });
  };
  _updateAccountInfo = (accountInfo) => {
    this.setState({ accountInfo });
  };
  _getModifiedWishList = (wishListModified) => {
    this.setState({ wishListModified });
  };
  _isSuccessAddedHandler = (isSuccessAdded) => {
    this.setState({ isSuccessAdded }, () => {
      $.magnificPopup.open({
        items: {
          src: '#item-modal',
          type: 'inline'
        }
      });
    });
    isSuccessAdded ? this._fetchSubCategoryItems() : null;
    $('.mfp-close').empty();
  };
  _onClickBackBtnHandler = (e) => {
    e.preventDefault();
    window.history.back();
  };
  _handlerIsSignUp = (isSignUp = false) => {
    this.setState({isSignUp});
  };
  _compareToSortOptions = (a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }

    return 0;
  };

  _activeSearchHandler = () => {
    const { isSearchActive } = this.state;

    this.setState({ isSearchActive: !isSearchActive });
  }

  render() {
    const activeEvent = (this.state.isCeremony) ? 31 : 32;
    const ddlData = this.props.ddlData ? this.props.ddlData : [];
    const categoryOptions = this._getcategoryOptions(ddlData, activeEvent);
    const sortedOptions = categoryOptions.sort(this._compareToSortOptions);
    const optionElements = this._renderCategoryOptions(sortedOptions);
    const eventOptions = this._renderEventOptions(this.props.events);
    const activeCategoryIndex = this._getActiveCategoryIndex(ddlData, activeEvent);
    const activeCategoryName = this.state.isSearchedItem ? this.state.items[0].subCategoryName : this._getActiveCategoryName(ddlData, activeCategoryIndex);

    return (
      <section className="container">
        <div className="row">
          <div className="xs-12 lg-12">
            <a onClick={this._onClickBackBtnHandler} className="back-btn"><i className="icon-arrow-right" />BACK TO WISHLIST</a>
            <h1 className="main-title">{`${ (this.state.isCeremony) ? 'Ceremony' : 'Reception' } Items`}</h1>
            <hr className="st-mini-div" />
            <p className="desc-copy">
                Storyboard your dream destination wedding from ceremony to reception with our Wedding Wishlists.
                Browse countless décor options, menu items, photography & videography choices, entertainment enhancements and more,
                and add your favourites to your wishlist.
            </p>
          </div>

          {/* <div className="xs-12 lg-4 catalog-circle">
            <WeddingCircle />
          </div> */}

          <div className="xs-12 actions-wrapper">
            <div className="row">
              <div className="xs-12 ttl-select">
                <h5 className="gold-label">SELECT CATEGORIES</h5>
              </div>

              <div className={`xs-12 lg-4 xxl-3 control-wrapper custom-ddl ${ (this.state.isSearchActive) ? 'disabled' : '' }`}>
                <select key={this.state.isCeremony} name="ceremony-filter" id="ceremony-filter" onChange={this._eventDdlHandler} required disabled={ this.state.isSearchActive }>
                  {eventOptions}
                </select>
              </div>

              <div className={`xs-12 lg-4 xxl-3 control-wrapper custom-ddl ${ (this.state.isSearchActive) ? 'disabled' : '' }`}>
                <select name="category-filter" id="category-filter" onChange={this._categoryDdlHandler} required disabled={ this.state.isSearchActive }>
                  <option disabled value="default">Please select a category</option>
                  {optionElements}
                </select>
              </div>
              <div className="xs-12 xxl-4 control-wrapper search-wrapper">
                <input type="checkbox" name="searchBox" onChange={ this._activeSearchHandler } id="searchBox" />
                <label htmlFor="searchBox" className="find-label">
                  <i className="icon-arrow-right"/>find an item by id code
                </label>
                <div className="search-content">
                  <input type="text" name="searchCode" id="searchCode" onChange={this._handleInputSearch} maxLength="20"/>
                  <span className="search-btn" onClick={this._searchItemByCode}><i className="icon-search"/></span>
                  <strong className={this.state.notFound ? 'not-found' : 'hide'}>Item not found.</strong>
                  <p className="example-event">Ex. <span>SAXOPHONEPLAYER-C</span></p>
                </div>
              </div>
            </div>
          </div>

          <div className="xs-12">
            <div className="tri-dvdr pr"/>
          </div>

          <div className="xs-12 items-wrapper">
            <ReactLoader className={'catalog-loader'}/>
            { (this.state.activeCategory) ?
              <CategoryItem
                categoryName={ activeCategoryName }
                itemsByEvent={ this.state.items }
                modalUpdateHandler={ this._updateItemDetail }
                isSuccessAddedHandler={this._isSuccessAddedHandler}
                userId={this.state.accountInfo.id}
                isSearchedItem={this.state.isSearchedItem}
              />
              : <h2 className="xs-12 select-txt">PLEASE SELECT A CATEGORY!</h2>
            }
          </div>
          <Modal id="item-modal">
            <ReactLoader className={'sk-loader-item'}/>
            <ItemPanel
              itemData={this.state.itemDetails}
              isSignUpHandler={this._handlerIsSignUp}
              isSuccessAdded={this.state.isSuccessAdded}
              wishListModified={this.state.wishListModified}
              userId={this.state.accountInfo.id}
              modalUpdateHandler={this._updateItemDetail}
              isSuccessAddedHandler={this._isSuccessAddedHandler}/>
          </Modal>
          <Modal id="dashboard-modal">
            <LoginPanel
              isSignUp={this.state.isSignUp}
              handlerIsSignUp={this._handlerIsSignUp}
              isAddItem
              countries={this.props.countries}
              itemDetails={this.state.itemDetails}
              isSuccessAddedHandler={this._isSuccessAddedHandler}
              updateAccountInfo={this._updateAccountInfo}
              modalUpdateHandler={this._updateItemDetail}
              getModifiedWishList={this._getModifiedWishList}/>
          </Modal>
        </div>
      </section>
    );
  }
}
